import { httpService } from '@/services';
import { AccountResponse } from '@/types';

export const getAccount = async (): Promise<AccountResponse['data']> => {
  try {
    const response = await httpService.get<AccountResponse>('account', {
      useToken: true,
    }, false);
    return response.data;
  } catch (error) {
    console.error('Errore nel recupero dell\'account:', error);
    throw new Error('Errore nel recupero dell\'account');
  }
};